import React, { useEffect, useState } from "react";
import { ErrorBoundary } from "./ErrorBoundary";
import { useRoutes as reactRouterUseRoutes, wrapComponent, wrapUseRoutes } from "./SentryDependencies";
import { LoggerProvider } from "./useLogger";
const sentryLoggerHOC = ({ logger, fallback = React.createElement(React.Fragment, null) }) => {
    const useRoutes = wrapUseRoutes(reactRouterUseRoutes, () => logger.getSentryClient?.());
    return ({ customerId }) => (Component) => {
        const SentryLogger = (props) => {
            const [WrappedComponent, setWrappedComponent] = useState();
            useEffect(() => {
                logger.onMount(customerId);
                setWrappedComponent(() => wrapComponent(Component));
                return () => logger.onUnmount();
            }, []);
            return WrappedComponent ? (React.createElement(LoggerProvider, { logger: logger },
                React.createElement(ErrorBoundary, { captureException: logger.captureException, fallback: fallback },
                    React.createElement(WrappedComponent, { ...props, useRoutes: useRoutes })))) : null;
        };
        return SentryLogger;
    };
};
export { sentryLoggerHOC };
